<template>
  <v-dialog :value="open" persistent max-width="490">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text>{{message}}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" color="error" text @click="handleDecline">{{declineText}}</v-btn>
        <v-btn :loading="loading" color="success" text @click="handleConfirm">{{confirmText}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    declineText: {
      type: String,
      default: 'No'
    },
    confirmText: {
      type: String,
      default: 'Yes'
    },
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },

    handleDecline() {
      this.$emit('decline')
    }
  },
}
</script>